import { useEffect, useMemo } from "react";

type SpacerEntry = {
  id: string;
  color: string;
};

const colorStack: SpacerEntry[] = [];

const updateDomState = () => {
  if (typeof document === "undefined") {
    return;
  }
  const root = document.documentElement;
  const body = document.body;
  if (!root) {
    return;
  }

  const activeEntry = colorStack[colorStack.length - 1];
  const color = activeEntry?.color;

  if (color) {
    root.style.setProperty("--mobile-top-spacer-background", color);
    body?.style.setProperty("--mobile-top-spacer-background", color);
  } else {
    root.style.removeProperty("--mobile-top-spacer-background");
    body?.style.removeProperty("--mobile-top-spacer-background");
  }

  if (body) {
    if (activeEntry) {
      body.dataset.mobileTopSpacerSource = activeEntry.id;
      body.dataset.mobileTopSpacerColor = activeEntry.color;
    } else {
      delete body.dataset.mobileTopSpacerSource;
      delete body.dataset.mobileTopSpacerColor;
    }
  }
};

export const registerMobileTopSpacerColor = (id: string, color: string) => {
  if (!color) return;
  const existingIndex = colorStack.findIndex((entry) => entry.id === id);
  if (existingIndex !== -1) {
    colorStack.splice(existingIndex, 1);
  }
  colorStack.push({ id, color });
  updateDomState();
};

export const unregisterMobileTopSpacerColor = (id: string) => {
  const index = colorStack.findIndex((entry) => entry.id === id);
  if (index === -1) {
    return;
  }
  colorStack.splice(index, 1);
  updateDomState();
};

const generateId = () => `mobile-top-spacer-${Math.random().toString(36).slice(2)}`;

export const useMobileTopSpacerColor = (color?: string | null) => {
  const sourceId = useMemo(() => generateId(), []);

  useEffect(() => {
    if (color) {
      registerMobileTopSpacerColor(sourceId, color);
      return () => {
        unregisterMobileTopSpacerColor(sourceId);
      };
    }

    // If no color is provided make sure we release any previous registration.
    unregisterMobileTopSpacerColor(sourceId);
    return () => {
      unregisterMobileTopSpacerColor(sourceId);
    };
  }, [color, sourceId]);
};
